import { css } from 'emotion';

import { fonts } from '../../../../styles';

const column = (minWidth: string, maxWidth: string = minWidth) => css`
  max-width: ${maxWidth};
  min-width: ${minWidth};
  white-space: nowrap;
`;

const plateCell = css`
  div {
    margin: 0 auto;
  }
`;

const searchField = css`
  width: 350px;
  margin-right: 20px;
`;

const tablePlaceholder = css`
  font-weight: ${fonts.weight.light};
  font-size: ${fonts.size.small};
`;

const boldText = css`
  font-weight: ${fonts.weight.medium};
`;

const table = css`
  table-layout: fixed;
`;

const icon = css`
  margin-right: 10px;
`;

const row = css`
  display: flex;
  margin: 20px 0px 20px 20px;
`;

const footer = css`
  margin: 20px;
`;

const footerWarning = css`
  background: rgba(244, 247, 249, 0.5);
  border-radius: 3px;
  padding: 11px 16px;
  margin-top: 20px;
`;

const placeholder = css`
  content: "";
  border: none;
  margin: 0;
  padding: 70px 0 40px;
`;

export default {
  placeholder,
  footerWarning,
  footer,
  row,
  icon,
  column,
  plateCell,
  searchField,
  tablePlaceholder,
  boldText,
  table,
};
